itsoftApp.createModule("animateScroll", ["windowResize"], function() {
    var maxMobileWidth = 767;
    var module = this;
    var loaded = false;
    var pageHeader = document.querySelector("[data-fixed='true']");
    var viewportSize = itsoftApp.utils.getViewportSize();
    var currentScrollTrigger;
    var scrollTriggerSections;

    var getViewportSize = function () {
      viewportSize = itsoftApp.utils.getViewportSize();
    }

    /* В эту функцию передаем DOM-элемент, до которого должна прокручиваться страница */
    var startScroll = function (target, padding) {
      var defaultPadding = 0;
      if (typeof window.ScrollTrigger !== "undefined") {
        ScrollTrigger.refresh();
        currentScrollTrigger = ScrollTrigger.getById("3d-rotate");

        if (currentScrollTrigger) {
          currentScrollTrigger.disable();
        }
      } else {
        scrollTriggerSections = document.querySelectorAll(".js-scroll-trigger.js-invisible");
        Array.prototype.forEach.call(scrollTriggerSections, function (scrollTriggerSection) {
          scrollTriggerSection.classList.remove("js-scroll-trigger");
          scrollTriggerSection.classList.remove("js-invisible");
        });
      }

      /* Проверяем: если на странице шапка зафиксирована, то возможно стоит сделать смещение 
      */
      if (pageHeader) {
        /* получаем высоту шапки */
        if (!itsoftApp.commonVars.headerHeight) {
          itsoftApp.utils.getHeaderHeight();
        }

        /* если есть data-атрибут, добавляем смещение */
        if (target.getAttribute("data-offset") === "true") {
          if (viewportSize <= maxMobileWidth) {
            defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
          } else {
            defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 2;
          }
        } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
          defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
        } else if (target.getAttribute("data-offset") === "none") {
          defaultPadding = 0;
        } else {
          defaultPadding = itsoftApp.commonVars.headerHeight - 4;
        }
      }

      var settings = {
        offset: defaultPadding,
        speed: 200
      }
      
      var scroll = new SmoothScroll();

      scroll.animateScroll(target, 1, settings);
    }

    var load = function (target, padding) {
      if (!loaded) {
        itsoftApp.loadScript("/assets/scripts/smoothScroll/smooth-scroll.min.js", function () {
          loaded = true;

          var toTargetScrollStop = function (event) {
              if (currentScrollTrigger) {
                currentScrollTrigger.enable();
              }

              if (scrollTriggerSections) {
                Array.prototype.forEach.call(scrollTriggerSections, function (scrollTriggerSection) {
                  scrollTriggerSection.classList.add("js-scroll-trigger");
                  scrollTriggerSection.classList.add("js-invisible");
                  // itsoftApp.modules.scrollEffects.show();
                  scrollTriggerSections = undefined;
                });
              }
          }

          document.addEventListener("scrollStop", toTargetScrollStop, false);
          startScroll(target, padding);
        });
      } else {
        startScroll(target, padding);
      }
    }

    var initAnimateScroll = function (el, padding) {
      el.addEventListener("click", function (evt) {
        evt.preventDefault();
        var scrollId = evt.currentTarget.href;
      
        if (!scrollId || !(scrollId = scrollId.split('#')[1])) {
          return;
        }

        var target = document.querySelector('#' + scrollId);
        load(target);
      });
    }

    var links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    Array.prototype.forEach.call(links, function (el) {
      initAnimateScroll(el);
    });

    module.callback = load;

    itsoftApp.modules.windowResize.addEvent(getViewportSize);
});